import modelExtend from 'dva-model-extend';
import { query } from '../services/account';
import { model } from './common';

export default modelExtend(model, {
  namespace: 'account',

  state: {
    store: {},
    ids: [],
  },

  effects: {

    * query({ payload = {}, output }, { call, put }) {
      const data = yield call(query, payload);
      output && (output.value = data);

      if (data.success) {
        const store = {};
        const ids = [];
        data.accounts.map((item) => {
          store[item.id] = item;
          ids.push(item.id);
          return item;
        });
        yield put({
          type: 'updateState',
          payload: { store, ids },
        });
      } else {
        throw data;
      }
    },
  },

  reducers: {
  },
});



// WEBPACK FOOTER //
// ./src/models/account.js